import { styled } from "@mui/material/styles";
import { Button as MuiButton } from "@mui/material";

const getButtonStyles = (props) => {
  switch (true) {
    case props.primary:
      return {
        color: "var(--button-primary-text)",
        backgroundColor: "var(--button-primary-bg)",
        textTransform: "capitalize",
        border: "0px",
        "&:hover": {
          backgroundColor: "var(--button-primary-bg)",
          border: "0px"
        }
      };
    case props.secondary:
      return {
        color: "var(--button-secondary-text)",
        backgroundColor: "var(--button-secondary-bg)",
        textTransform: "capitalize",
        "&:hover": {
          backgroundColor: "var(--button-secondary-bg)"
        }
      };
    case props.subtle:
      return {
        color: "var(--button-subtle-text)",
        backgroundColor: "var(--button-subtle-bg)",
        textTransform: "capitalize",
        "&:hover": {
          backgroundColor: "var(--button-subtle-bg)"
        }
      };
    case props.outlined:
      return {
        color: "var(--button-primary-text)",
        borderColor: "var(--button-primary-text)",
        textTransform: "capitalize",
        "&:hover": {
          backgroundColor: "none"
        }
      };
    case props.text:
      return {
        color: "var(--button-primary-text)",
        textTransform: "capitalize",
        "&:hover": {
          backgroundColor: "none"
        }
      };
    case props.disabled:
      return {
        color: "var(--button-disabled-text)",
        textTransform: "capitalize",
        backgroundColor: "var(--button-disabled-bg)"
      };
    default:
      return {
        color: "var(--button-primary-text)",
        backgroundColor: "var(--button-primary-bg)",
        textTransform: "capitalize",
        "&:hover": {
          backgroundColor: "var(--button-primary-bg)"
        }
      };
  }
};

const Button = styled(MuiButton, {
  shouldForwardProp: (prop) =>
    !["primary", "secondary", "subtle", "outlined", "text"].includes(prop)
})`
  ${(props) => getButtonStyles(props)};
`;

export default Button;
